import React, {useCallback, useState} from 'react';
import {Waypoint} from '@homeaway/react-unveil';
import edapWrapper from '@homeaway/edap-wrapper';

export default function WaypointContainer({children}) {
    const [unveiled, setUnveiled] = useState(false);
    const handleUnveil = useCallback(() => {
        if (unveiled) {
            // only want to trigger view event the first time
            return;
        }

        setUnveiled(true);
        edapWrapper().push({
            name: 'page.module.view',
            data: {
                actionlocation: 'family_collection_serp_ad',
            },
        });
    }, [setUnveiled, unveiled]);

    return (
        <Waypoint
            label="family-collection-banner-waypoint"
            onEnter={handleUnveil}
        >
            {children}
        </Waypoint>
    );
}
